import styled from 'styled-components';
import { palette } from 'pages/AnyfitMall/theme';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 24px;
`;

const Card = styled.div`
  background: ${palette.White};
  border-radius: 12px;
  padding: 24px 20px 16px;
  width: 100%;
  max-width: 360px;
  text-align: center;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${palette.Gray900};
  margin-bottom: 8px;
`;

const Sub = styled.div`
  font-size: 13px;
  color: ${palette.Gray600};
  line-height: 1.5;
  margin-bottom: 20px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PrimaryBtn = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: ${palette.AnyBlue};
  color: ${palette.White};
  border: none;
`;

export function AgreementRequiredModal({ onConfirm = () => {} }) {
  return (
    <Backdrop role="dialog" aria-modal="true" aria-labelledby="ar-modal-title">
      <Card>
        <Title id="ar-modal-title">이용 동의가 필요해요</Title>
        <Sub>구매내역을 확인하려면 개인정보 활용에 동의해주세요.</Sub>
        <Buttons>
          <PrimaryBtn onClick={onConfirm}>동의하러 가기</PrimaryBtn>
        </Buttons>
      </Card>
    </Backdrop>
  );
}
